import { capitalizarPalabras } from '../../../common/upperCaseWord';
import { urlFlag } from '../../../common/urlBase';

/** URL de la bandera del idioma del curso. */
export const courseLanguageFlagUrl = (course) => {
    const path = course?.language?.path;
    return path ? `${urlFlag}${path}` : null;
};

/**
 * Título del chat en vivo: «Ing-01 - Inglés B1».
 * @param {object | null | undefined} course
 * @returns {string}
 */
export const courseChatTitle = (course) => {
    if (!course) return 'Chat';

    const identifier = course.identifier?.trim()
        ? capitalizarPalabras(course.identifier.trim())
        : '';
    const language = course.language?.name?.trim()
        ? capitalizarPalabras(course.language.name.trim())
        : '';
    const level = course.level?.name?.trim()
        ? capitalizarPalabras(course.level.name.trim())
        : '';

    let langLevel = '';
    if (language && level) {
        langLevel = `${language} ${level}`;
    } else if (language || level) {
        langLevel = language || level;
    }

    if (identifier && langLevel) return `${identifier} - ${langLevel}`;
    if (identifier) return identifier;
    if (langLevel) return langLevel;
    return 'Chat';
};

const normalizeCourseStatus = (status) => String(status || '').toLowerCase().trim();

/** Clases del badge de estatus (misma paleta que tarjetas / tabla de cursos). */
export const getCourseStatusBadgeClass = (status) => {
    switch (normalizeCourseStatus(status)) {
        case 'abierto':
            return 'bg-sky-100 text-sky-700 border-sky-200';
        case 'en curso':
            return 'bg-emerald-100 text-emerald-700 border-emerald-200';
        case 'completado':
            return 'bg-indigo-100 text-indigo-600 border-indigo-200';
        case 'cancelado':
            return 'bg-gray-100 text-gray-600 border-gray-200';
        case 'finalizado':
            return 'bg-rose-100 text-rose-500 border-rose-200';
        default:
            return 'bg-gray-100 text-gray-600 border-gray-200';
    }
};
